/** This file is automatically generated, any changes will be overwritten **/
export const frontendVersion = '3.32.3';
